import { AxiosResponse } from 'axios';
import instance from '../Axios/instance';
import { TMigrationFaqsResponse } from 'models/migrationCentre';

export class MigrationCentreService {
  public static async getMigrationFaqs(
  ): Promise<TMigrationFaqsResponse> {
    const response: AxiosResponse<TMigrationFaqsResponse> = await instance.get('/profiles/migration-faq');
    return response.data;
  }
}
export default MigrationCentreService;
